var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.perViewDia.visible,
        title: "",
        width: "430px",
        top: "7vh",
        "destroy-on-close": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.perViewDia, "visible", $event)
        },
      },
    },
    [
      _vm.perViewDia.visible
        ? _c("iframe", {
            staticStyle: { width: "390px", height: "800px" },
            attrs: {
              id: "ifPerviewShop",
              src: _vm.perViewDia.perViewUrl,
              frameborder: "0",
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }